import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Heart, ExternalLink } from 'lucide-react';
import api from '../../lib/api';

const Footer = () => {
    const [chapters, setChapters] = useState([]);

    useEffect(() => {
        api.get('/chapters').then(res => setChapters(res.data)).catch(() => {});
    }, []);

    return (
        <footer className="bg-card border-t border-border mt-auto" data-testid="main-footer">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
                    {/* Brand */}
                    <div className="md:col-span-2">
                        <Link to="/" className="flex items-center gap-2 mb-4">
                            <img 
                                src="https://customer-assets.emergentagent.com/job_partner-network-11/artifacts/e97jx98f_HAAPE%20Rainbow%20logo.jpg" 
                                alt="HAAPE" 
                                className="h-10 w-10 rounded-lg object-cover"
                            />
                            <span className="font-heading font-light text-xl text-foreground">
                                Employment & Support Hub
                            </span>
                        </Link>
                        <p className="text-muted-foreground text-sm max-w-md">
                            The National Autistic Employment & Support Ecosystem. Building inclusive 
                            employment ecosystems that empower autistic adults across the United States.
                        </p>
                        <p className="text-muted-foreground text-sm mt-4 flex items-center gap-1">
                            Built with <Heart className="h-4 w-4 text-destructive" /> by autistic adults
                        </p>
                    </div>

                    {/* Quick Links */}
                    <div>
                        <h3 className="font-heading font-semibold text-sm uppercase tracking-wider text-muted-foreground mb-4">
                            Quick Links
                        </h3>
                        <ul className="space-y-2">
                            <li>
                                <Link 
                                    to="/directory" 
                                    className="text-sm text-muted-foreground hover:text-foreground transition-colors duration-150"
                                >
                                    Browse Public Directory
                                </Link>
                            </li>
                            <li>
                                <Link 
                                    to="/submit" 
                                    className="text-sm text-muted-foreground hover:text-foreground transition-colors duration-150"
                                >
                                    Submit a Resource
                                </Link>
                            </li>
                            <li>
                                <Link 
                                    to="/apply" 
                                    className="text-sm text-muted-foreground hover:text-foreground transition-colors duration-150"
                                >
                                    Apply For Membership
                                </Link>
                            </li>
                            <li>
                                <Link 
                                    to="/impact" 
                                    className="text-sm text-muted-foreground hover:text-foreground transition-colors duration-150"
                                >
                                    Impact Dashboard
                                </Link>
                            </li>
                            <li>
                                <Link 
                                    to="/map" 
                                    className="text-sm text-muted-foreground hover:text-foreground transition-colors duration-150"
                                >
                                    Interactive Map
                                </Link>
                            </li>
                            <li>
                                <Link 
                                    to="/news" 
                                    className="text-sm text-muted-foreground hover:text-foreground transition-colors duration-150"
                                >
                                    Resource Library
                                </Link>
                            </li>
                            <li>
                                <Link 
                                    to="/members" 
                                    className="text-sm text-muted-foreground hover:text-foreground transition-colors duration-150"
                                >
                                    Member Directory
                                </Link>
                            </li>
                            <li>
                                <a 
                                    href="https://www.haape.org" 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    className="text-sm text-muted-foreground hover:text-foreground transition-colors duration-150 flex items-center gap-1"
                                >
                                    HAAPE Main Site
                                    <ExternalLink className="h-3 w-3" />
                                </a>
                            </li>
                        </ul>
                    </div>

                    {/* Chapters - only show if any exist */}
                    {chapters.length > 0 && (
                    <div>
                        <h3 className="font-heading font-semibold text-sm uppercase tracking-wider text-muted-foreground mb-4">
                            Chapters
                        </h3>
                        <ul className="space-y-2 text-sm text-muted-foreground">
                            {chapters.map((ch) => (
                                <li key={ch.chapter_id}>
                                    <Link to={`/directory?state=${encodeURIComponent(ch.state)}`} className="hover:text-foreground transition-colors">
                                        {ch.name}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                    )}
                </div>

                {/* Bottom Bar */}
                <div className="border-t border-border mt-8 pt-8 flex flex-col sm:flex-row justify-between items-center gap-4">
                    <p className="text-xs text-muted-foreground">
                        &copy; {new Date().getFullYear()} HAAPE Foundation. All rights reserved.
                    </p>
                    <p className="text-xs text-muted-foreground">
                        Helping Autistic Adults Perform & Excel
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
